import {
  notifySave,
  notifySubmit,
  notifyAttachmentDel,
  notifyAttachment,
  notify,
} from '../../redux/utils/notifications/notifications';
import { getAxiosInstance } from '../utils/axios-api';
import {
  FETCH_TIMESHEET,
  FETCH_ALL_TIMESHEETS,
  ADD_TIMESHEET,
  FETCH_ATTACHMENTS,
  DEFAULTERS_REPORTS,
  SUMMARY_REPORTS,
  TASK_REPORTS,
  GET_ALL_PROJECTS,
  SUMMARY_BY_DAY_REPORTS,
  GET_ACTIVE_PROJECT
} from '../actionTypes';
import { getAccessToken, download_csv } from '../utils/customMethods';
import moment from 'moment';
import { DB_DATE_FORMAT } from '../constants';

export const fetchTimesheet = body => async dispatch => {
  const response = await getAxiosInstance().get(
    `/getTimesheetDetails?userId=${body.userId}&role=${body.role}&fromDate=${
      body.fromDate
    }&toDate=${body.toDate}&access_token=${getAccessToken()}`
  );
  if (response.status === 200) {
    dispatch({
      type: FETCH_TIMESHEET,
      payload: response.data.users[0] || {},
    });
    if (response.data.users[0] && response.data.users[0].weekly[0]) {
      dispatch({
        type: FETCH_ATTACHMENTS,
        payload: response.data.users[0].weekly[0].attachments,
      });
    } else {
      dispatch({ type: FETCH_ATTACHMENTS, payload: [] });
    }
  }
};

export const fetchAllTimesheets = body => async dispatch => {
  const response = await getAxiosInstance().get(
    `/getTimesheetDetails?userId=${body.userId}&role=${body.role}&year=${
      body.year
    }&access_token=${getAccessToken()}`
  );
  dispatch({ type: FETCH_ALL_TIMESHEETS, payload: response.data || {} });
};

export const addTimesheet = timesheet => async dispatch => {
  const response = await getAxiosInstance().post(
    `/timesheet?access_token=${getAccessToken()}`,
    timesheet
  );
  dispatch({ type: ADD_TIMESHEET, payload: response.data });
};

export const approveTimesheet = body => async dispatch => {
  const response = await getAxiosInstance().put(
    `/approveTimesheet?userId=${body.userId}&access_token=${getAccessToken()}`,
    body
  );
  if (response.status === 200) {
    if(body.status === 'APPROVED'){
      notify('success', 'Timesheet approved successfully.');
    }else if(body.status === 'APPROVAL_PENDING'){
      notify('success', 'Timesheet approved reverted successfully.');
    }else{
      
    }
    return true;
  } else {
    notify('error', 'Timesheet approved failed.');
    return false;
  }
};

export const fetchAllProjects = () => async dispatch => {
  const response = await getAxiosInstance().get(
    `/getProjectList?access_token=${getAccessToken()}`
  );
  dispatch({ type: GET_ALL_PROJECTS, payload: response.data || [] });
};

export const fetchSummaryReportsCsv = resp => async dispatch => {
  try {
    const response = await getAxiosInstance().get(
      `/tsSummaryReportExport?fromDate=${resp.fromDate}&toDate=${resp.toDate}&empType=${
        resp.empType
      }&access_token=${getAccessToken()}`
    );
    if (response.status === 200) {
      download_csv(
        response.data,
        'SummaryReport[' + resp.fromDate + ' To ' + resp.toDate + '].csv'
      );
    } else {
      notify('error', response.errorMessage);
    }
  } catch (ex) {
    notify('error', ex);
  }
};

export const fetchSummaryByDayReport = resp => async dispatch => {
  // console.log('RESP IN ACTIONS', resp)
  try {
    const response = await getAxiosInstance().get(
      `/tsSummaryByDay?fromDate=${resp.fromDate}&toDate=${resp.toDate}&type=${
        resp.type
      }&access_token=${getAccessToken()}`
    );
    dispatch({
      type: SUMMARY_BY_DAY_REPORTS,
      payload: response.data.data || [],
    });
  } catch (ex) {
    dispatch({ type: SUMMARY_BY_DAY_REPORTS, payload: undefined });
  }
};

export const fetchDefaultTimesheet = user => async dispatch => {
  const response = await getAxiosInstance().get(
    `/TsSummaryReport?fromDate=${user.fromDate}&toDate=${
      user.toDate
    }&isDefaulter=true&access_token=${getAccessToken()}`
  );
  dispatch({ type: DEFAULTERS_REPORTS, payload: response.data });
};

export const fetchSummaryReports = user => async dispatch => {
  const response = await getAxiosInstance().get(
    `/TsSummaryReport?fromDate=${user.fromDate}&toDate=${
      user.toDate
    }${user.projectCode? '&projectCode='+user.projectCode:''}&includeTasks=${user.includesTasks}&byManager=${user.byManager}&access_token=${getAccessToken()}`
  );
  dispatch({ type: SUMMARY_REPORTS, payload: response.data });
};
export const fetchTaskReport=obj=>async dispatch =>{
  const response=await getAxiosInstance().get(
    `/taskReport?fromDate=${moment(obj.fromDate).format(DB_DATE_FORMAT) }&toDate=${
      moment(obj.toDate).format(DB_DATE_FORMAT)
    }${obj.projectId? '&projectId='+obj.projectId:''}&onboardingTypeId=${obj.onboardingTypeId}&milestoneRecId=${obj.milestoneRecId}&clientManager=${obj.byManager}&access_token=${getAccessToken()}`
  );
  dispatch({ type: TASK_REPORTS, payload: response.data });
}
export const fetchTaskReportsCsv = obj => async dispatch => {
  try {
    const response = await getAxiosInstance().get(
      `/taskReport?fromDate=${moment(obj.fromDate).format(DB_DATE_FORMAT) }&toDate=${
        moment(obj.toDate).format(DB_DATE_FORMAT)
      }${obj.projectId? '&projectId='+obj.projectId:''}&onboardingTypeId=${obj.onboardingTypeId}&milestoneRecId=${obj.milestoneRecId}&clientManager=${obj.byManager}&access_token=${getAccessToken()}`
    );
    if (response.status === 200) {
      download_csv(
        response.data,
        'TaskReport[' + moment(obj.fromDate).format(DB_DATE_FORMAT) + ' To ' + moment(obj.toDate).format(DB_DATE_FORMAT) + '].csv'
      );
    } else {
      notify('error', response.errorMessage);
    }
  } catch (ex) {
    notify('error', ex);
  }
};
export const fetchAllActiveProjects = user => async dispatch => {
  const response = await getAxiosInstance().get(
    `/getProjectList?access_token=${getAccessToken()}`
  );
  dispatch({ type: GET_ACTIVE_PROJECT, payload: response.data });
};

export const updateTimesheet = (timesheet, mode) => async dispatch => {
  const response = await getAxiosInstance().post(
    `/saveTimesheet?access_token=${getAccessToken()}`,
    timesheet
  );

  if (response.status === 200) {
    dispatch({ type: FETCH_TIMESHEET, payload: response.data.users[0] });
    if (response.data.users[0] && response.data.users[0].weekly[0]) {
      dispatch({
        type: FETCH_ATTACHMENTS,
        payload: response.data.users[0].weekly[0].attachments,
      });
    } else {
      dispatch({ type: FETCH_ATTACHMENTS, payload: [] });
    }
    if (mode === 'Save') {
      notifySave();
    }
    if (mode === 'Submit') {
      notifySubmit();
    }
  }
};

export const removeAttachment = (attachmentId, attachment) => async dispatch => {
  const response = await getAxiosInstance().delete(
    `/deleteFile?Id=${attachmentId}&access_token=${getAccessToken()}`
  );

  notifyAttachmentDel();
};

export const fetchAttachments = attachment => async dispatch => {
  const response = await getAxiosInstance().get(
    `/getTimesheet?access_token=${getAccessToken()}`,
    attachment
  );
  dispatch({ type: FETCH_ATTACHMENTS, payload: response.data });
};

export const uploadTimeSheetAttachments = (
  file,
  fromDate,
  toDate,
  userId
) => async dispatch => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('fromDate', fromDate);
  formData.append('toDate', toDate);
  formData.append('userId', userId);
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  };

  try {
    const response = await getAxiosInstance().post(
      `/uploadAttachment?access_token=${getAccessToken()}`,
      formData,
      config
    );
    if ((response || {}).status === 200) {
      notifyAttachment();
      dispatch({ type: FETCH_ATTACHMENTS, payload: response.data });
      return response.data;
    } else {
      return undefined;
    }
  } catch (ex) {
    return undefined;
  }
};
